import React, { Component } from 'react'
import styled from 'styled-components'

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }

    this.closeModal = this.closeModal.bind(this)
  }

  closeModal() {
    this.setState( { open: false } )
  }

  open = () => {
    this.setState( { open: true } )
  }

  render() {
    //
    // if(!this.state.open)
    //   return null

    return (
      <ModalBackground onClick={ () => this.setState({ open: false }) } open={this.state.open}>
        <ModalContainer
          width={this.props.width}
          height={this.props.height}
          onClick={ e => e.stopPropagation() }
          style={this.props.modalStyles}
        >

          { this.props.children }

        </ModalContainer>
      </ModalBackground>
    )
  }
}

export default Modal;

const ModalBackground = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050 ;
  width: 100vw;
  height: 100vh;
  background-color: #22222288;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.open ? '#22222288' : '#22222200'};
  visibility: ${props => props.open ? 'visible' : 'hidden'};
  transition: background .2s linear, visibility .2s linear;
`

const ModalContainer = styled.div `
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: white;
  padding: 20px;
  color: black;
  text-align: center;
  padding: 16px 45px;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0,0,0,0.15);
  max-height: 50%;
`

ModalContainer.defaultProps = {
    width: "300px",
    height: "300px",
}



// WEBPACK FOOTER //
// /src/components/internal/Modals/Modal.js